'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const Formatters=require('../../../../dist-es6/client/formatters');
const StatisticsPanelHelpers=require('../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

BaseStatisticsPanelDirective=function(_BaseControllerBacked){_inherits(BaseStatisticsPanelDirective,_BaseControllerBacked);function BaseStatisticsPanelDirective(){_classCallCheck(this,BaseStatisticsPanelDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}BaseStatisticsPanelDirective.prototype.







factory=function factory(){
let directive=_BaseControllerBacked.prototype.factory.call(this);
directive.transclude=!0;
directive.replace=!0;
return directive;
};_createClass(BaseStatisticsPanelDirective,[{key:'controller',get:function(){return BaseStatisticsPanelDirectiveController}},{key:'objectBindings',get:function(){return['dimensions']}},{key:'textBindings',get:function(){return['title','subtitle']}},{key:'templateUrl',get:function(){return'/templates/directives/statisticsPanels/baseStatisticsPanelTemplate'}}]);return BaseStatisticsPanelDirective}(BaseControllerBackedDirective);let


BaseStatisticsPanelDirectiveController=function(){
function BaseStatisticsPanelDirectiveController($scope,$element,$timeout,elementService){var _this2=this;_classCallCheck(this,BaseStatisticsPanelDirectiveController);
this._$scope=$scope;
this._$element=$element;
this._$timeout=$timeout;
this._elementService=elementService;

this._debouncedUpdateStyles=_.debounce(function(){return _this2._$timeout(function(){return _this2._updateStyles()})},25);
this._$scope.$on('resize::resize',function(){return _this2._debouncedUpdateStyles()});
this._debouncedUpdateStyles();
}BaseStatisticsPanelDirectiveController.prototype.





_updateStyles=function _updateStyles(){
const panelBodyChildren=this.panelBodyChildren;

if(panelBodyChildren.length!==2){
throw new Error('StatisticsPanel body must contain exactly two top-level elements');
}

const[leftElement,rightElement]=panelBodyChildren;
const subComponentDimensions=StatisticsPanelHelpers.getSubComponentDimensionsFrom(this.dimensions);

angular.element(panelBodyChildren[0]).attr('style',`width: ${subComponentDimensions.left.width}px !important; height: ${subComponentDimensions.left.height}px !important;`);
angular.element(panelBodyChildren[1]).attr('style',`width: ${subComponentDimensions.right.width}px !important; height: ${subComponentDimensions.right.height}px !important;`);
};_createClass(BaseStatisticsPanelDirectiveController,[{key:'panelBodyChildren',get:function(){return this._panelBodyChildren||(this._panelBodyChildren=this._elementService.selectElement(this._$element).find('.panel-body').children())}}]);return BaseStatisticsPanelDirectiveController}();


module.exports=BaseStatisticsPanelDirective;
//# sourceMappingURL=baseStatisticsPanelDirective.js.map
